import { render } from "./adminPermisosForm-Component.vue?vue&type=template&id=2475cf12"
import script from "./adminPermisosForm-Component.vue?vue&type=script&lang=js"
export * from "./adminPermisosForm-Component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__